module.exports = __webpack_public_path__ + "img/image5.0a0720a9.png";